export enum DocumentsCategory {
    PERSONAL_DOCUMENT = 'personal_document',
    DRIVER_DOCUMENTS = 'driver_documents'
}
